const TURBO_STRIP_PREFIX = "turboStrip";

export const TURBO_STRIP_TEST_IDS = {
    WRAPPER: `${TURBO_STRIP_PREFIX}_wrapper`,
    STRIP_MSG: `${TURBO_STRIP_PREFIX}_strip_msg`,
    RIGHT_ARROW: `${TURBO_STRIP_PREFIX}_chevron`,
    ANIMATED_TEXT: `${TURBO_STRIP_PREFIX}_animated_text`,
    CTA_TEXT: `${TURBO_STRIP_PREFIX}_cta_text`,
};
